import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { successOnboardActions } from './success-onboard.actions';
import { challengeActions } from '@fitup-monorepo/challenge/lib/state/challenge.actions';
import { map } from 'rxjs/operators';

@Injectable()
export class SuccessOnboardEffects {
  private readonly actions$ = inject(Actions);

  public loadChallenge$ = createEffect(() =>
    this.actions$.pipe(
      ofType(successOnboardActions.loadAndJoinChallenge),
      map(action => challengeActions.loadChallenge(action))
    )
  );

  public joinChallenge$ = createEffect(() =>
    this.actions$.pipe(
      ofType(successOnboardActions.loadAndJoinChallenge),
      map(action => challengeActions.joinChallenge(action))
    )
  );

  public addChallengeId$ = createEffect(() =>
    this.actions$.pipe(
      ofType(successOnboardActions.loadAndJoinChallenge),
      map(action => challengeActions.addInvitedChallengeId(action))
    )
  );
}
